export default function IconCaptionSwitch() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M0 6C0 4.89543 0.895431 4 2 4H30C31.1046 4 32 4.89543 32 6V26C32 27.1046 31.1046 28 30 28H2C0.895431 28 0 27.1046 0 26V6ZM13 25C13 24.4477 13.4477 24 14 24H29C29.5523 24 30 24.4477 30 25C30 25.5523 29.5523 26 29 26H14C13.4477 26 13 25.5523 13 25ZM3 20C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H18C18.5523 22 19 21.5523 19 21C19 20.4477 18.5523 20 18 20H3ZM2 25C2 24.4477 2.44772 24 3 24H10C10.5523 24 11 24.4477 11 25C11 25.5523 10.5523 26 10 26H3C2.44772 26 2 25.5523 2 25ZM22 20C21.4477 20 21 20.4477 21 21C21 21.5523 21.4477 22 22 22H29C29.5523 22 30 21.5523 30 21C30 20.4477 29.5523 20 29 20H22Z"
        fill="currentColor" />
    </svg>
  );
}
